import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Trophy, Users, Zap } from "lucide-react";
import { brl, catName } from "../lib/api";
import { Countdown } from "./Countdown";

export const ContestCard = ({ contest, index = 0, large }) => (
  <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.07 }}>
    <Link
      to={`/concursos/${contest.id}`}
      data-testid={`contest-card-${contest.id}`}
      className={`group relative flex flex-col justify-end overflow-hidden rounded-2xl border border-white/10 transition-[border-color,box-shadow] duration-300 neon-border ${large ? "min-h-[420px]" : "min-h-[320px]"}`}
    >
      <img src={contest.cover_url} alt={contest.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-[#0A0A0F]/70 to-[#0A0A0F]/10" />
      <div className="absolute left-4 top-4 flex gap-2">
        {contest.is_main && (
          <span className="flex items-center gap-1 rounded-md bg-lime-400 px-2.5 py-1 font-mono-tech text-[10px] font-bold uppercase tracking-wider text-black">
            <Zap className="h-3 w-3" /> Principal
          </span>
        )}
        <span className={`rounded-md px-2.5 py-1 font-mono-tech text-[10px] uppercase tracking-wider ${contest.status === "active" ? "bg-black/60 text-cyan-300" : "bg-red-500/20 text-red-300"}`}>
          {contest.status === "active" ? "Aberto" : "Encerrado"}
        </span>
      </div>
      <div className="relative p-6">
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-cyan-300">{catName(contest.category)}</p>
        <h3 className={`mt-1 font-display font-black uppercase leading-none ${large ? "text-4xl" : "text-2xl"}`}>{contest.title}</h3>
        <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-slate-300">
          <span className="flex items-center gap-1.5"><Trophy className="h-4 w-4 text-lime-300" /> {contest.prize}</span>
          <span className="flex items-center gap-1.5"><Users className="h-4 w-4 text-cyan-300" /> {contest.entries_count} fotos</span>
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-4">
          <span className="font-mono-tech text-xs text-slate-400">
            Inscrição: <b className="text-white">{contest.entry_fee > 0 ? brl(contest.entry_fee) : "Grátis"}</b>
          </span>
          {contest.status === "active" && <Countdown deadline={contest.deadline} compact testId={`contest-countdown-${contest.id}`} />}
        </div>
      </div>
    </Link>
  </motion.div>
);
